export default __webpack_public_path__ + "static/media/pin_Preservers_colour.9d60fdc1.png";